export default __webpack_public_path__ + "static/media/DAMEXPartner.5077e57b.svg";